export const SEND_LOGIN_REQUEST = "auth/SEND_LOGIN_REQUEST";
export const SEND_LOGIN_SUCCESS = "auth/SEND_LOGIN_SUCCESS";
export const SEND_LOGIN_ERROR = "auth/SEND_LOGIN_ERROR";
export const LOGOUT_USER = "auth/LOGOUT_USER";
export const UPDATE_TOKENS = "auth/UPDATE_TOKENS";
